import React, { Fragment } from 'react';
import ComponentMapper from 'library/components/story-blok/component-mapper';
import { resolve } from 'library/helpers/path-resolver';
import { string } from 'prop-types';
import { Route, GetUnalteredPath } from 'library/util/core-router';
import FourOhFourPage from 'core/pages/four-oh-four';
import AppContext from 'context/app';
import Loading from 'components/loading';
import withConfig from 'util/hoc/with-config';
import { getStory } from 'library/components/story-blok/services/get-story';
import { object } from 'prop-types';

class StoryblockPage extends React.Component {
  static defaultProps = {
    path: '/'
  }

  static propTypes = {
    path: string.isRequired
  }

  state = {
    story: {},
    loading: true,
    error: false
  }

  componentDidMount() {
    this.load();
  }

  load = async () => {
    this.setState({
      loading: true
    });

    const { configuration, path } = this.props;
    let pathname = path||'/';

    try {
       const data = await getStory(
      `${resolve(
        this.props.configuration,
        'environment/storyblok_root',
        'journey'
      )}${pathname}`,
       resolve(configuration,'environment/journey/entity/name', '').toLowerCase(),
        pathname
    );

      this.setState({
        story: data?.story || data,
        loading: false
      });
    } catch (e) {
      this.setState({
        error: true
      });
      console.error(e);
    }
    this.setState({
      loading: false
    });
  }

  render() {
    const {
      loading,
      story,
      error
    } = this.state;

    if (loading) {
      return <Loading />;
    }

    if (error) {
      console.error(e);
      return <FourOhFourPage />;
    }

    return (
      <Fragment>
        { resolve(story, 'content/body', []).map((c, i) => <ComponentMapper key={i} {...c} />) }
      </Fragment>
    );
  }
}

StoryblockPage.propTypes = {
  configuration: object
};

export default withConfig(StoryblockPage);

export const StoryBlokRoute = withConfig(({ configuration, ...props }) => (
  <Route {...props} render={(routeProps)=>(
    <AppContext.Consumer>
      {({app}) => (
        <StoryblockPage configuration={configuration} path={GetUnalteredPath(routeProps.location.pathname, app, props.path)} key={routeProps.location.pathname} />
      )}
    </AppContext.Consumer>
  )} />
));
